import React, { useState, useEffect } from "react";
import {
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter,
    ModalBody, Button, Input, FormControl, FormLabel, useToast
} from "@chakra-ui/react";
import api from "../../utils/axios";

const ResetPasswordModal = ({ isOpen, onClose, userId, userName }) => {
    const [password, setPassword] = useState("");
    const [repeatPassword, setRepeatPassword] = useState("");
    const toast = useToast();

    useEffect(() => {
        if (isOpen) {
            setPassword("");
            setRepeatPassword("");
        }
    }, [isOpen]);

    const handleSubmit = async () => {
        if (password !== repeatPassword) {
            toast({
                title: "Greška",
                description: "Lozinke se ne podudaraju.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
            return;
        }

        try {
            const response = await api.post('/auth/reset-password', {
                userId,
                password,
                repeatPassword
            });

            toast({
                title: "Uspjeh",
                description: `Lozinka za korisnika ${userName} je promijenjena.`,
                status: "success",
                duration: 3000,
                isClosable: true,
            });

            onClose();
        } catch (error) {
            toast({
                title: "Greška",
                description: error.response?.data || "Došlo je do greške pri promijeni lozinke.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Izmjena lozinke za: <strong>{userName}</strong></ModalHeader>
                <ModalBody>
                    <FormControl>
                        <FormLabel>Nova lozinka</FormLabel>
                        <Input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </FormControl>
                    <FormControl mt={4}>
                        <FormLabel>Ponovi lozinku</FormLabel>
                        <Input
                            type="password"
                            value={repeatPassword}
                            onChange={(e) => setRepeatPassword(e.target.value)}
                        />
                    </FormControl>
                </ModalBody>
                <ModalFooter>
                    <Button variant="ghost" onClick={onClose}>Otkaži</Button>
                    <Button colorScheme="blue" ml={3} onClick={handleSubmit}>Promijeni</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ResetPasswordModal;
